import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Toast from './Toast';

const ToastContext = createContext({
    toast: { show: false, message: '', type: 'success', title: 'Success!' },
    showToast: () => {}
});

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({ show: false, message: '', type: 'success', title: 'Success!' });
    const showToast = (message, type = 'success', title = 'Success!') => {
        setToast({ show: true, message, type, title });
        setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 3000);
    };

    const handleClose = () => {
        setToast((prev) => ({ ...prev, show: false }));
    };

    return (
        <ToastContext.Provider value={{ toast, showToast }}>
            {children}
            <Toast show={toast.show} message={toast.message} type={toast.type}
                title={toast.title} onClose={handleClose}
            />
        </ToastContext.Provider>
    );
};

// The validation is already correctly added at the bottom:
ToastProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useToast = () => useContext(ToastContext);
